import { Box } from "@material-ui/core";
import { useSelector } from "react-redux";

import { COLORS } from "../../../theme/colors";
import { getTableHeaders } from "../tableHeaders";
import { BuildingsTable } from "../../demo/components/BuildingsTable";
import { CalculatingComponent } from "../../demo/noSolar/steps/ConfirmStep";

export const ConfirmData = ({ rows, setRows, deleteBuilding, isDataConfirmed, setStep }) => {
  const { clusters } = useSelector((state) => state.auth);

  if (isDataConfirmed) {
    return (
      <Box borderRadius={8} bgcolor={COLORS.darks[0][10]} height="100%" minHeight={300}>
        <CalculatingComponent rowsCount={rows.length} setStep={setStep} />
      </Box>
    );
  }
  return (
    <BuildingsTable
      rows={rows}
      setRows={setRows}
      deleteBuilding={deleteBuilding}
      headers={getTableHeaders(clusters[0].preliminary_stage)}
      draftUrl="/onboarding/base/portfolio-registration/draft/"
    />
  );
};
